import { Navigate } from "react-router-dom";
import { hasPermission } from "../../utils/permissionUtils";

/**
 * @param {string} [permissionCode]
 * @param {string} [action]
 * @param {{ permissionCode: string, action?: string }[]} [anyOf] — đủ một quyền là được (ưu tiên hơn permissionCode đơn)
 */
export default function PermissionWrapper({ permissionCode, action, anyOf, children }) {
  if (Array.isArray(anyOf) && anyOf.length > 0) {
    const ok = anyOf.some((entry) => {
      const code = entry?.permissionCode;
      const act = entry?.action ?? action;
      if (!code || !act) return false;
      return hasPermission(code, act);
    });
    if (!ok) return <Navigate to="/403" replace />;
    return children;
  }

  if (permissionCode && action && !hasPermission(permissionCode, action)) {
    return <Navigate to="/403" replace />;
  }

  return children;
}
